import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-form-checkliste-lkt-biovario',
  templateUrl: './form-checkliste-lkt-biovario.component.html',
  styleUrls: ['./form-checkliste-lkt-biovario.component.scss', '../checklisten.scss'],
})
export class FormChecklisteLktBiovarioComponent implements OnInit {
  @Input() form: FormGroup;

  constructor() {}

  ngOnInit() {}
}
